import { render, staticRenderFns } from "./leave-list.vue?vue&type=template&id=95c38376&"
import script from "./leave-list.vue?vue&type=script&lang=js&"
export * from "./leave-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports